module.exports = __webpack_public_path__ + "static/media/home.94b31b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/home.jpg
// module id = 1584
// module chunks = 27